import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
//读取配置
import { userInfo, globalData, globalConfig } from './util/globalStore'
//语言切换
import { getLanguage, changeLanguage, changeHrefLang, getLangByPath } from './util/index'
//网络请求
import { pageVisitLog, getOrgInfo } from './api/index'
import {generateUUID} from "./util/cryptoHelper";

const routes = [
    { path: '/:lang?', component: () => import('./components/signup.vue') },
    { path: '/error/:lang?', component: () => import('./components/error.vue') },
    { path: '/login/:lang?', component: () => import('./components/login.vue') },
    {
        path: '/talk/:lang?', component: () => import('./components/talk.vue'),
        meta: {
            needLogin: false,
            notNeedFooter: true
        }
    },
    {
        path: '/talk_test/:lang?', component: () => import('./components/talk_test.vue'),
        meta: {
            needLogin: false,
            notNeedFooter: true
        }
    },
    {
        path: '/signup/:lang?', component: () => import('./components/signup.vue'),
        meta: {
            notNeedFooter: true
        }
    },
    {
        path: '/exercise/:lang?', component: () => import('./components/exercise.vue'),
        meta: {
            notNeedFooter: true
        }
    },
    {
        path: '/chatRecord/:lang?', component: () => import('./components/chatRecord.vue'),
        meta: {
            notNeedFooter: true
        }
    },
    { path: '/payResult/:lang?', component: () => import('./components/payResult.vue') },
    {
        path: '/shareHistory/:lang?', component: () => import('./components/shareHistory.vue'),
        meta: {
            notNeedFooter: true
        }
    },
    { path: '/changePassword/:lang?', component: () => import('./components/changePassword.vue') },
    { path: '/payVerify/:lang?', component: () => import('./components/payVerify.vue') }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const config = globalConfig()
    const gData = globalData()
    //更新用户信息
    const user = userInfo()
    console.log(to)
    //app到web快捷登录
    if(to.query.id && to.query.token) {
        user.id = to.query.id
        user.login_access_token = to.query.token
    }
    //渠道统计
    if (to.query.ref) {
        config.ref = to.query.ref
    }
    if (to.query.channel) {
        config.channel = to.query.channel
    }
    //
    if (config.channel == "meta") {
        //读取剪贴板
        navigator.clipboard
        .readText()
        .then((v) => {
          console.log("获取剪贴板成功：", v)
          let metaJson = JSON.parse(v)
          if (metaJson.fbclid) {
            config.metaJson = metaJson
          }
        })
        .catch((v) => {
          console.log("获取剪贴板失败: ", v);
        });
    }

    if (to.query.uuid && to.query.uuid.length > 0) {
        config.tempUserID = to.query.uuid
    }
    if (!config.tempUserID || config.tempUserID.length === 0) {
        config.tempUserID = generateUUID()
    }
    const lang = getLangByPath(to.path)
    if (lang) {
        changeLanguage(lang)
    } else {
        const defaultLang = getLanguage()
        //fix首页的路径匹配
        if (to.path === "/") {
            to.path = ""
        }
        to.path = to.path + "/" + defaultLang;
        changeLanguage(defaultLang)
    }
    //更新标签
    changeHrefLang(to)
    
    if (user.isLogin) {
        user.updateUser()
    }
    //跳转处理
    if (to.matched.length === 0 && to.query.from != 'exercise') {  // 如果未匹配到路由跳首页
        console.log("未匹配到路由跳首页")
        next('/')
    } else if (to.meta.needLogin == true && !user.isLogin) {
        //自动跳转登录页面
        gData.loginReferer = to.fullPath
        next('/login')  // 如果匹配到正确跳转
    } else {
        window.scrollTo(0, 0);
        next()  // 如果匹配到正确跳转
    }
})


router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
    pageVisitLog(window.location.href)
});

export { router }